"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9.514 4.126l-9 5a1 1 0 000 1.748l9 5a1 1 0 00.972 0l9-5a1 1 0 000-1.748l-9-5a1 1 0 00-.972 0zM10 6.144l6.94 3.855L10 13.855 3.059 9.999 10 6.144z"];
//# sourceMappingURL=layer-outline.js.map